import type { RefCallback } from 'react';
import React from 'react';
import { IMaskInput } from 'react-imask';

interface CustomMaskProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  mask: string;
}

const CustomTextMask = React.forwardRef<HTMLElement, CustomMaskProps>(
  function CustomTextMask(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask={props.mask}
        definitions={{
          '#': /[1-9]/,
        }}
        inputRef={ref as RefCallback<HTMLTextAreaElement | HTMLInputElement>}
        onAccept={(value: any) =>
          onChange({ target: { name: props.name, value } })
        }
        overwrite
      />
    );
  }
);

export default CustomTextMask;
